
/*
|--------------------------------------------------------------------------
| Utilities: Error Log
|--------------------------------------------------------------------------
*/
/**
 * Display errors in the console
 *
 * @param {object} options
 * @param {string} options.controller - function that was called
 * @param {string} options.message - error message to display
 * @param {string} options.line - line number to reference
 */
__gh__webApp.utilities.errorLog = function(options){
	var controller	= (options.controller) 	? "CONTROLLER: "+options.controller+"\n" 	: "",
		message 	= (options.message) 	? "ERROR: "+options.message+"\n" 			: "",
		line 		= (options.line) 		? "LINE: "+options.line+"\n" 				: "";
	console.log(message+controller+line);
};